import { useNavigate } from 'react-router-dom';
import './MobileHomePage.scss';

const HERO_CARDS = [
  {
    title: 'Roster',
    subtitle: 'See shifts, assign people, and keep the week under control.',
    eyebrow: 'Coordinate',
    accent: 'copper',
    to: '/start',
    meta: 'Daily scheduling flow',
  },
  
  {
    title: 'Manage Trade Jobs',
    subtitle: 'Keep quotes, scheduling, and active jobs moving in one place.',
    eyebrow: 'Operate',
    accent: 'ink',
    to: '/start',
    meta: 'Field operations control',
  },
  {
    title: 'Manage Licence, Regos, Leave',
    subtitle: 'Keep licences, registrations, leave, and related admin in one connected flow.',
    eyebrow: 'Scale',
    accent: 'forest',
    to: '/start',
    meta: 'Compliance and workforce admin',
  },
  
  {
    title: 'Advertise a Job',
    subtitle: 'Put urgent staffing needs in front of people ready to move.',
    eyebrow: 'Promote',
    accent: 'ocean',
    to: '/start',
    meta: 'Hire temporary talent',
  },
  {
    title: 'Search Jobs',
    subtitle: 'Find fast-moving casual and flexible work near you.',
    eyebrow: 'Discover',
    accent: 'sunrise',
    to: '/jobs',
    meta: 'Public jobs board',
  },
];

const MOBILE_STOCK_CARDS = [
  {
    title: 'Rostering',
    symbol: '↗',
    image:
      'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80',
    alt: 'Team members gathered around a laptop during a work planning session.',
  },
  {
    title: 'Trade Job Coordination',
    symbol: '◌',
    image:
      'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=900&q=80',
    alt: 'People collaborating at a desk with notebooks and devices.',
  },
  {
    title: 'Regos, licences, and compliance',
    symbol: '✦',
    image:
      'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80',
    alt: 'A professional reviewing workforce information on a tablet.',
  },
];

const DESKTOP_STOCK_CARDS = [
  {
    title: 'Live teams',
    symbol: '◌',
    image:
      'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80',
    alt: 'A workplace team in discussion around a large shared table.',
  },
  {
    title: 'Scheduling rhythm',
    symbol: '↘',
    image:
      'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80',
    alt: 'A manager coordinating work plans with a small group.',
  },
  {
    title: 'Operations control',
    symbol: '✦',
    image:
      'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
    alt: 'A modern operations workspace with people moving through the office.',
  },
];

export default function MobileHomePage() {
  const navigate = useNavigate();
  const featuredDesktopCard = HERO_CARDS[0];
  const openAuth = (mode) => navigate(`/start?auth=${mode}`);

  return (
    <div className="mobile-home-page">
      <div className="mobile-home-glow mobile-home-glow-left" />
      <div className="mobile-home-glow mobile-home-glow-right" />

      <main className="mobile-home-shell">
        <div className="mobile-home-top-actions">
          <button type="button" className="mobile-home-top-button mobile-home-top-button-tertiary" onClick={() => navigate('/about-us')}>
            About Us
          </button>
          
          <button type="button" className="mobile-home-top-button mobile-home-top-button-secondary" onClick={() => openAuth('signIn')}>
            Sign In
          </button>
          <button type="button" className="mobile-home-top-button" onClick={() => navigate('/contact-us')}>
            Contact Us
          </button>
          <button type="button" className="mobile-home-top-button mobile-home-top-button-secondary" onClick={() => navigate('/pricing')}>
            Pricing
          </button>
        </div>

        <section className="mobile-home-mobile-layout">
          <section className="mobile-home-hero">
            <div className="mobile-home-hero-copy">
              <span className="mobile-home-kicker">Welcome</span>
              <h1>Manage workforce coordination on the go.</h1>
              <p>
                Complete control on rostering and job allocations including licences, regos, and compliance.
              </p>
            </div>
            <div className="mobile-home-hero-panel">
              
              <div className="mobile-home-hero-tags">
                <span>Roster</span>
                <span>Leave</span>
                <span>Timesheet</span>
                
                <span>Trade Jobs</span>
                <span>Regos</span>
                <span>Licence</span>
              </div>
            </div>
            <div className="desktop-home-actions">
                <button type="button" className="mobile-home-top-button" onClick={() => openAuth('signIn')}>
                  Sign In
                </button>
                <button type="button" className="mobile-home-top-button mobile-home-top-button-secondary" onClick={() => openAuth('signUp')}>
                  Join Now
                </button>
              </div>
          </section>

          <section className="mobile-home-intro-strip">
            <div>
              
            </div>
           
          </section>

          <section className="mobile-home-visual-strip" aria-label="Mobile inspiration gallery">
            {MOBILE_STOCK_CARDS.map((item) => (
              <article key={item.title} className="mobile-home-visual-card">
                <img src={item.image} alt={item.alt} loading="lazy" />
                <div className="mobile-home-visual-overlay">
                  <span className="mobile-home-visual-symbol">{item.symbol}</span>
                  <div>
                    <span className="mobile-home-visual-label"></span>
                    <h3>{item.title}</h3>
                  </div>
                </div>
              </article>
            ))}
          </section>

          <div className="mobile-home-symbol-row" aria-hidden="true">
            <span>↗ Jobs moving</span>
            <span>◌ Shifts aligned</span>
            <span>✦ Teams supported</span>
          </div>

          <section className="mobile-home-grid">
            {HERO_CARDS.map((card, index) => (
              <article
                key={card.title}
                className={`mobile-home-card mobile-home-card-${card.accent}`}
              >
                <div className="mobile-home-card-orb" />
                <span className="mobile-home-card-eyebrow">{card.eyebrow}</span>
                <h2>{card.title}</h2>
                <p>{card.subtitle}</p>
                <div className="mobile-home-card-footer">
                  <span className="mobile-home-card-meta">{card.meta}</span>
                  {index === 0 && (
                    <div className="mobile-home-card-actions">
                      <button type="button" className="mobile-home-card-cta mobile-home-card-cta-secondary" onClick={() => openAuth('signUp')}>
                        Join Now
                      </button>
                      <button type="button" className="mobile-home-card-cta" onClick={() => openAuth('signIn')}>
                        Sign In
                      </button>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </section>
        </section>

        <section className="desktop-home-layout">
          <section className="desktop-home-hero">
            <div className="desktop-home-copy">
              <span className="mobile-home-kicker">Welcome</span>
              <h1>Manage workforce coordination on the go.</h1>
              <p>
                Complete control on Regos, licence, leave, availability, roster and job allocations
              </p>
              <div className="desktop-home-symbol-row" aria-hidden="true">
                <span>◌ Regos</span>
                <span>✦ Licence</span>
                <span>• Leave</span>
                <span>• Timesheet</span>
                <span>◌ Roster</span>
                <span>• Jobs</span>
              </div>
              <div className="desktop-home-actions">
                <button type="button" className="mobile-home-top-button" onClick={() => openAuth('signIn')}>
                  Sign In
                </button>
                <button type="button" className="mobile-home-top-button mobile-home-top-button-secondary" onClick={() => openAuth('signUp')}>
                  Join Now
                </button>
              </div>
            </div>

            <div className="desktop-home-spotlight desktop-home-spotlight-primary">
              <span className="desktop-home-spotlight-label">{featuredDesktopCard.eyebrow}</span>
              <h2>{featuredDesktopCard.title}</h2>
              <p>{featuredDesktopCard.subtitle}</p>
              <div className="desktop-home-photo-stack" aria-label="Desktop workforce gallery">
                {DESKTOP_STOCK_CARDS.map((item) => (
                  <article key={item.title} className="desktop-home-photo-card">
                    <img src={item.image} alt={item.alt} loading="lazy" />
                    <div className="desktop-home-photo-overlay">
                      <span className="desktop-home-photo-symbol">{item.symbol}</span>
                      <span>{item.title}</span>
                    </div>
                  </article>
                ))}
              </div>
              <div className="desktop-home-tile-actions">
                <button type="button" className="desktop-home-tile-link desktop-home-tile-link-secondary" onClick={() => openAuth('signUp')}>
                  Join Now
                </button>
                <button type="button" className="desktop-home-tile-link" onClick={() => openAuth('signIn')}>
                  Sign In
                </button>
              </div>
            </div>
          </section>

          <section className="desktop-home-mosaic">
            {HERO_CARDS.slice(1).map((card) => (
              <article
                key={card.title}
                className={`desktop-home-tile desktop-home-tile-${card.accent}`}
              >
                <span className="desktop-home-spotlight-label">{card.eyebrow}</span>
                <h3>{card.title}</h3>
                <p>{card.subtitle}</p>
                <div className="desktop-home-tile-footer">
                  <span>{card.meta}</span>
                </div>
              </article>
            ))}
          </section>
        </section>

        <footer className="mobile-home-footer">
          <p>@2024 Effiez. All rights reserved</p>
        </footer>
      </main>
    </div>
  );
}